import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedia = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M9.27273 16.818H6C4.89697 16.818 3.95455 16.4362 3.17273 15.6726C2.39091 14.9089 2 13.9756 2 12.8726C2 11.9271 2.28485 11.0847 2.85455 10.3453C3.42424 9.60588 4.1697 9.13316 5.09091 8.9271C5.39394 7.81194 6 6.90891 6.90909 6.218C7.81818 5.5271 8.84848 5.18164 10 5.18164C11.4182 5.18164 12.6212 5.67558 13.6091 6.66346C14.597 7.65134 15.0909 8.85437 15.0909 10.2726C15.9273 10.3695 16.6212 10.7301 17.1727 11.3544C17.7242 11.9786 18 12.7089 18 13.5453C18 14.4544 17.6818 15.2271 17.0455 15.8635C16.4091 16.4998 15.6364 16.818 14.7273 16.818H10.7273V11.618L11.8909 12.7453L12.9091 11.7271L10 8.818L7.09091 11.7271L8.10909 12.7453L9.27273 11.618V16.818Z" })]
});
const ForwardRef = forwardRef(SvgMedia);
export default ForwardRef;
